import { TrackingProps } from "../../types/component";
import { FilterValue, GroupFilter } from "../../types/filter";
import { PillGroup } from "../FilterPill/PillGroup";

interface InputGroupPillDesktopProps {
  filter: GroupFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  tracking: TrackingProps;
}

export const InputGroupPillDesktop = ({
  filter,
  filterValues,
  setFilterValues,
  tracking,
}: InputGroupPillDesktopProps) => {
  return (
    <PillGroup
      filter={filter}
      filterValues={filterValues}
      setFilterValues={setFilterValues}
      tracking={tracking}
    />
  );
};
